import { Loader } from 'rsuite';

import React, {useState, useEffect} from 'react';
import { LOGO as logo } from '../config/logo';
import UserService from '../services/User.service';
import { BRAND_LOGO_ALT } from '../config/brand';

function KycExternoPage(props) {
    const hash = window.location.hash;
    const [route, queryString] = hash.split('?');
    const params = new URLSearchParams(queryString);
    const user_id = params.get('user');    // "abc123"
    const token = params.get('token');    // "TOKEN"

    const userService = new UserService();

    const [isMobile, setIsMobile] = useState(false);

    const [kyc, setKyc]  = useState({});

    const checkKyc = async (userID) => {
        try {
            const kycResponse = await userService.post({ user_id: user_id, token: token },"user/generate/kyc/externo");

            if (kycResponse) {
                setKyc(kycResponse);
            }
        } catch (error) {
            console.error("Erro ao buscar KYC:", error);
        }
    };

    useEffect(() => {
        checkKyc(user_id)
        const checkIsMobile = () => setIsMobile(window.innerWidth <= 768);

        checkIsMobile(); // Verifica ao carregar
        window.addEventListener("resize", checkIsMobile); // Atualiza se a janela for redimensionada

        if (window.innerWidth <= 768 && kyc?.url) {
            window.location.href = kyc.url;
        }

        return () => window.removeEventListener("resize", checkIsMobile);
    }, [user_id]);

    return (
        <div className="flex min-h-screen items-center justify-center bg-[radial-gradient(circle_at_50%_0%,rgba(179,248,41,0.08),transparent_45%),linear-gradient(180deg,#f8faf3_0%,#f2f5ee_100%)] px-4 py-10">
            <div className="w-full max-w-[420px]">
                <div className="mb-8 flex justify-center">
                    <img className="h-10 w-auto" src={logo} alt={BRAND_LOGO_ALT} />
                </div>

                <div className="rounded-3xl border border-slate-200/70 bg-white p-8 shadow-[0_20px_55px_-30px_rgba(15,23,42,0.35)]">
                    {!kyc.base64_qrcode ? (
                        <div className="flex h-60 items-center justify-center">
                            <Loader content="Carregando..." vertical size="md" />
                        </div>
                    ) : (
                        <div className="flex flex-col items-center text-center">
                            <p className="text-sm text-app-muted">
                                📷 Para validar sua identidade, escaneie o QR Code abaixo usando seu celular. Você será direcionado para a verificação de selfie e documentos.
                            </p>
                            <img
                                alt="Qrcode"
                                src={`data:image/svg+xml;base64,${kyc.base64_qrcode}`}
                                className="mt-8 h-[240px] w-[240px]"
                            />
                        </div>
                    )}
                </div>
            </div>
        </div>
    )
}

export default KycExternoPage;
